import { d as s, f as E, k as h } from "./keys-CQjWNUL0.mjs";
import { i as w } from "./correct-is-regexp-logic-DUuS52mu.mjs";
import { r as m } from "./includes-sHzLfkB4.mjs";
var g = {}, c = {}, l = {}, _;
function b() {
  return _ || (_ = 1, function(r) {
    var a = s, i = w;
    a(r, "__esModule", {
      value: !0
    }), r.isEnabled = o;
    var n = i(m());
    function o(t) {
      var e;
      try {
        if (!((e = window == null ? void 0 : window.document) != null && e.body))
          throw Error("The DOM has not loaded");
        return t === "encore" ? u() : f(t);
      } catch (d) {
        if (window.ENV === "dev")
          throw Error(`Error checking feature "${t}": ${d}`);
        return !1;
      }
    }
    const f = (t) => {
      var e;
      const {
        featureToggles: d = ""
      } = window.document.body.dataset;
      return !!(t && (0, n.default)(e = d.split(/\s+/g)).call(e, t));
    }, u = () => window.document.body.getAttribute("data-fabric-theme") === "encore";
  }(l)), l;
}
var v;
function q() {
  return v || (v = 1, function(r) {
    var a = s;
    a(r, "__esModule", {
      value: !0
    }), r.ifFeature = n;
    var i = b();
    function n(o, f, u) {
      return (0, i.isEnabled)(o) ? f : u;
    }
  }(c)), c;
}
(function(r) {
  var a, i, n = s, o = E, f = h;
  n(r, "__esModule", {
    value: !0
  });
  var u = q();
  o(a = f(u)).call(a, function(e) {
    e === "default" || e === "__esModule" || e in r && r[e] === u[e] || n(r, e, {
      enumerable: !0,
      get: function() {
        return u[e];
      }
    });
  });
  var t = b();
  o(i = f(t)).call(i, function(e) {
    e === "default" || e === "__esModule" || e in r && r[e] === t[e] || n(r, e, {
      enumerable: !0,
      get: function() {
        return t[e];
      }
    });
  });
})(g);
export {
  g as f
};
//# sourceMappingURL=index-LyFokDcn.mjs.map
